import { IDistributedRoundRobin } from "../types/DistributedRoundRobin";
import { ESubmitFrom, IEnquiryEntry } from "../types/EnquiryEntry";

export function  getLeadSourceDisplay (data: IEnquiryEntry | IDistributedRoundRobin | undefined ) {
    if ([ESubmitFrom.LANDING_PAGE, ESubmitFrom.LISTING_PAGE].includes(data?.submitFrom as ESubmitFrom)) {
      return "Lead Form Submission";
    }
    if (data?.leadSource) {
      return data.leadSource;
    }
    return "N/A";
  }